import { Select } from 'radix-ui'
import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui/text'

export function SelectLabel({
  className,
  children,
  ...props
}: React.ComponentProps<typeof Select.Label>) {
  return (
    <Select.Label
      className={cn('text-text-secondary px-3 py-1', className)}
      asChild
      {...props}
    >
      <Text appearance="CAPTION">{children}</Text>
    </Select.Label>
  )
}
